<template>
  <div class="dark-showcase-section py-5 text-white position-relative overflow-hidden" id="favoritos">
    <!-- Bowl Decorativo Flotante Disperso (Fit Cakes) -->
    <div class="floating-bowl-decor bowl-favoritos d-none d-lg-block">
      <img
        :src="require('@/assets/img/NEW Delivery_2.png')"
        alt="Hot Cakes Fit"
        class="img-fluid floating-bowl-img"
      />
    </div>

    <div class="container position-relative z-1">
      
      <!-- Encabezado de la Sección de Favoritos -->
      <div class="text-center mb-5">
        <h2 class="roboto fw-bold fs-1 text-white text-uppercase mt-2 mb-2">
          Nuestros <span class="text-naranja">Favoritos</span>
        </h2>
        <p class="quicksand lead text-white-50 mx-auto" style="max-width: 620px; font-size: 1.05rem;">
          Explora los 4 pilares gastronómicos que hacen de The Fit Bar la opción saludable número uno en Cancún.
        </p>
      </div>

      <!-- 4 Tarjetas Verticales (Inspiradas en el diseño de referencia) -->
      <div class="row g-4 justify-content-center mb-4 pb-4 pb-lg-5">
        <div
          v-for="(card, index) in favoritosCards"
          :key="'fav-' + index"
          class="col-12 col-sm-6 col-lg-3"
        >
          <a href="#menu" class="favorite-tall-card d-flex flex-column rounded-4 overflow-hidden text-decoration-none h-100">
            <div class="tall-card-img-wrap position-relative">
              <img
                :src="card.img"
                :alt="card.titulo"
                class="w-100 h-100 tall-card-img"
              />
              <div class="tall-card-gradient"></div>
            </div>
            <div class="tall-card-body p-3 text-center bg-dark-card flex-grow-1 d-flex flex-column justify-content-between">
              <div>
                <h5 class="roboto fw-bold text-white mb-1 fs-6">{{ card.titulo }}</h5>
                <p class="small text-white-50 quicksand mb-2">{{ card.subtitulo }}</p>
              </div>
              <span class="card-link-text text-naranja fw-bold small">
                Ver platillos <i class="bi bi-arrow-right-short"></i>
              </span>
            </div>
          </a>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "Contenedor2",
  data() {
    return {
      favoritosCards: [
        {
          titulo: "Hot Cakes Fit & Bowls",
          subtitulo: "Avena entera, matcha, cacao y frutas",
          img: require("@/assets/img/galeria/HOTCAKES_MATCHA_FIT_CAKES.png"),
        },
        {
          titulo: "Platos Fuertes al Grill",
          subtitulo: "Top Sirloin, Salmón y Pechuga fresca",
          img: require("@/assets/img/galeria/PLATO_FUERTE_TOP_SIRLOIN.png"),
        },
        {
          titulo: "Sándwiches & Omelettes",
          subtitulo: "Pan multicereal y claras con vegetales",
          img: require("@/assets/img/galeria/SANDWICH_MASS_PECHUGA.png"),
        },
        {
          titulo: "Shakes & Bebidas Detox",
          subtitulo: "Proteína Whey Isolate y extractor verde",
          img: require("@/assets/img/galeria/BEBIDA_BATIDO_DE_PROTEÍNA.png"),
        },
      ],
    };
  },
};
</script>

<style scoped>
.dark-showcase-section {
  background-color: #0b0b0b;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
}

.text-naranja {
  color: #fd6f3c !important;
}

.dark-pill-badge {
  background: rgba(253, 111, 60, 0.15);
  border: 1px solid rgba(253, 111, 60, 0.35);
  color: #fd6f3c;
  padding: 4px 16px;
  border-radius: 50px;
  font-size: 0.75rem;
  font-weight: 800;
  letter-spacing: 1px;
}

/* 4 Tarjetas Verticales */
.favorite-tall-card {
  background-color: #1e2224;
  border: 1px solid rgba(255, 255, 255, 0.08);
  transition: all 0.35s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.favorite-tall-card:hover {
  transform: translateY(-8px);
  border-color: rgba(253, 111, 60, 0.4);
  box-shadow: 0 16px 35px rgba(0, 0, 0, 0.4);
}

.tall-card-img-wrap {
  height: 270px;
  background-color: #111;
  overflow: hidden;
}

.tall-card-img {
  object-fit: cover;
  transition: transform 0.5s ease;
}

.favorite-tall-card:hover .tall-card-img {
  transform: scale(1.08);
}

.tall-card-gradient {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.1) 0%, rgba(20, 23, 24, 0.7) 100%);
}

.tall-card-badge {
  position: absolute;
  top: 12px;
  left: 12px;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(4px);
  color: #fff;
  font-size: 0.75rem;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.15);
}

.bg-dark-card {
  background-color: #1e2224;
}

/* Cápsula Flotante de Beneficios */
.pillars-capsule-card {
  background: linear-gradient(145deg, #1f2527 0%, #171c1e 100%);
  border: 1px solid rgba(255, 255, 255, 0.12);
  max-width: 960px;
}

.pillar-icon-circle {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(253, 111, 60, 0.15);
  border: 1px solid rgba(253, 111, 60, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  transition: transform 0.3s ease;
}

/* Elementos Flotantes Dispersos (5 Meal Prep Bowls) */
.floating-bowl-decor {
  position: absolute;
  z-index: 2;
  pointer-events: none;
  filter: drop-shadow(0 15px 25px rgba(0, 0, 0, 0.7));
  transition: all 0.3s ease;
}

/* Bowl Decorativo Flotante Disperso (Fit Cakes) */
.bowl-favoritos {
  top: 25px;
  right: clamp(15px, 6vw, 110px);
  animation: floatBowlFavoritos 6s ease-in-out infinite alternate;
}

.floating-bowl-img {
  width: 215px;
  height: 215px;
  object-fit: contain;
  transform: rotate(10deg);
  transition: transform 0.3s ease;
}

.bowl-label-mini {
  background: rgba(15, 18, 20, 0.88);
  backdrop-filter: blur(8px);
  border: 1px solid rgba(253, 111, 60, 0.4);
  color: #fff;
  font-family: 'Montserrat', sans-serif;
  font-size: 0.72rem;
  font-weight: 700;
  padding: 3px 12px;
  border-radius: 20px;
  text-align: center;
  margin-top: -8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
  white-space: nowrap;
}

@keyframes floatBowlFavoritos {
  0% { transform: translateY(0) rotate(0deg); }
  100% { transform: translateY(14px) rotate(4deg); }
}
</style>
